// Constants
import { HARVEST_PRINT_PROPERTIES_SET } from './constants';

// Local Types
import {
    HarvestPrintPropertiesState,
    HarvestPrintPropertiesSetAction
} from './types';

/**
 * Dispatched when the harvest print properties are loaded by the scaffoldData request saga
 */
export function setHarvestPrintProperties(
    data: HarvestPrintPropertiesState
): HarvestPrintPropertiesSetAction {
    return {
        type: HARVEST_PRINT_PROPERTIES_SET,
        payload: data
    };
}
